<template>
    <div class="introductionBox">
       <businessBanner tabIndex="5"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">管理咨询</p>
            <p class="mt36 jies">瑞和安惠以"智控交付·品牌引擎"作为管理咨询业务的战略定位，将数智赋能的PMC全过程管理顾问服务提供商作为发展愿景，依托专业技术团队和数智化研发团队，自主开发惠管理全咨协同管理平台，实现数据资产化、协同平台化、管理智能化，积极推动"不驻场+平台化"的轻量化管理顾问模式落地。主导完成的曲阳县人民医院迁建项目入选"2025年保定市智能建造BIM应用项目名单"；高阳县环城水系项目入选"燕赵宜居县城范例项目综合性城市更新范例"。</p>
            <p class="mt20 jies">经过改革性的技术创新与服务升级，瑞和安惠管理咨询业务已全面提升了项目交付能力与管理效率，有效降低了管理成本与决策失误率，成为集团的能力中枢与品牌引擎。</p>
       </div>
       <!-- 资质资信 -->
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'">资质资信</div>
                    <ul class="qualify-list">
                        <li>房屋建筑工程监理甲级资质</li>
                        <li>市政公用工程监理乙级资质</li>
                    </ul>
                </div>
                <img :class="isMobile?'contImgShow':'fr manaImg1'" src="@/assets/businessScope/mana1.png" alt="">
            </div>
       </div>
       <!-- 服务范围 -->
       <div :class="isMobile?'mainM':'sec-outer'">
            <div :class="isMobile?'':'sec-inner'">
                <div :class="isMobile?'contTM':'sec-title'">服务范围</div>
                <div class="svc-layout">
                    <div class="svc-right">
                        <img class="svc-img" src="@/assets/businessScope/mana2.png" alt="">
                    </div>
                    <div class="svc-left">
                        <p class="svc-sub"><b>咨询产品</b></p>
                        <p class="svc-val">项目管理；管理顾问</p>
                        <p class="svc-sub"><b>数智化产品</b></p>
                        <p class="svc-val">SaaS产品(2)、数据产品(4)、模型产品(5)、数字孪生产品(1)</p>
                    </div>
                </div>
            </div>
       </div>
       <!-- 荣誉奖项 -->
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'sec-inner'">
                <div :class="isMobile?'contTM':'sec-title'">荣誉奖项</div>
                <div class="honor-grid">
                    <ul class="honor-col">
                        <li>河北省项目管理协会发起单位</li>
                        <li>河北省建筑市场发展研究会副会长</li>
                        <li>第三届中国建设工程BIM大赛卓越工程项目二等奖</li>
                        <li>第三届"龙图杯"全国BIM大赛综合组三等奖</li>
                        <li>第五届"龙图杯"全国BIM大赛综合组优秀奖</li>
                        <li>中国建协第八届建设工程BIM大赛三类成果</li>
                        <li>中施企协第五届工程建设行业BIM大赛三等成果</li>
                    </ul>
                    <ul class="honor-col">
                        <li>河北省第一届"燕赵杯"BIM技术应用大赛一等奖</li>
                        <li>河北省第二届"燕赵杯"BIM技术应用大赛二等奖</li>
                        <li>河北省第三届"燕赵杯"BIM技术应用大赛二类成果</li>
                        <li>河北省第四届"燕赵杯"BIM技术应用大赛一类成果</li>
                        <li>河北省第五届"燕赵杯"BIM技术应用大赛二类成果</li>
                        <li>河北省第六届"燕赵杯"BIM技术应用大赛一类成果</li>
                    </ul>
                </div>
            </div>
       </div>
       <!-- 典型业绩展示 -->
       <TypicalAchievement category-id="100143" :show-tabs="false" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
export default {
    name: 'ProjectManagement',
    components: { businessBanner, TypicalAchievement },
    data() {
        return {}
    },
    mounted() {}
}
</script>

<style scoped>
.introductionBox {
    padding-bottom: 50px;
}
.mainShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 42px;
}
.mobileShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 20px;
}
.main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 47px;
    padding-bottom: 100px;
}
.mainM {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.jies {
    line-height: 30px;
    text-indent: 2em;
}
.cont {
    width: 525px;
    color: #666;
}
.contM {
    width: 100%;
    color: #666;
    line-height: 30px;
}
.contM p {
    text-indent: 2em;
}
.contT {
    color: #247CD6;
    font-size: 28px;
    margin-top: 60px;
    margin-bottom: 31px;
}
.contTM {
    color: #247CD6;
    font-size: 28px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.contT+p {
    line-height: 36px;
    text-indent: 2em;
}
.contImgShow {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}
.manaImg1 {
    width: 432px;
    margin-right: 100px;
    margin-top: 23px;
}
.contLeft {
    width: 525px;
    color: #666;
}
.qualify-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.qualify-list li {
    line-height: 36px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
    color: #555;
}
.qualify-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 16px;
}
/* 板块标题 */
.sec-title {
    color: #247CD6;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 32px;
    padding-left: 14px;
    border-left: 4px solid #247CD6;
    line-height: 1;
}
.sec-outer {
    width: 100%;
    margin-top: 42px;
}
.sec-inner {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 60px;
}
/* 服务范围 */
.svc-layout {
    display: flex;
    align-items: flex-start;
    gap: 40px;
}
.svc-left {
    width: 380px;
    flex-shrink: 0;
}
.svc-right {
    flex: 1;
    min-width: 0;
}
.svc-img {
    width: 100%;
    border-radius: 8px;
}
.svc-sub {
    font-size: 15px;
    color: #333;
    margin: 22px 0 12px;
}
.svc-val {
    font-size: 14px;
    color: #555;
    line-height: 28px;
}
/* 荣誉奖项 */
.honor-grid {
    display: flex;
    gap: 30px;
}
.honor-col {
    flex: 1;
    list-style: none;
    padding: 0;
    margin: 0;
}
.honor-col li {
    line-height: 38px;
    padding-left: 18px;
    position: relative;
    font-size: 14px;
    color: #555;
}
.honor-col li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 17px;
}
</style>
